import React, { useEffect, useState } from "react";
import ClassNames from "classnames";
import {
	getFormValues,
	isValid
	// destroy
	// initialize,
	// getFormInitialValues
} from "redux-form";
import { useHistory } from "react-router-dom";

import {
	Modal,
	Button
	// ProgressIndicator
} from "rhombus-react";

import { useDispatch, useSelector } from "react-redux";

import {
	loadVersionDetails,
	getVersionInfo,
	clearVersionDetails
} from "reducers/VersionDetails";
import {
	isMaxDynamicSocialVersions,
	useModalStack
} from "utils/common";

import {
	// getVariables,
	addLibraryIdToVideos
} from "utils/VersionHelpers";
import { EDIT_SOCIAL_VERSION_2 } from "forms/list";


import Toolbar from "./Toolbar";
import SaveAsModal from "../SaveAsModal";
import EditSocialVersion from "./EditSocialVersion";
import InlineVersionPreview from "./InlineVersionPreview";


const formIsValid = isValid(EDIT_SOCIAL_VERSION_2);

export default function SocialVersionBlade(props){
	const history = useHistory()
		, commonModalProps = {
			type: "blade",
			setAppTitle:false,

			xClose: true,
			allowFullScreen: true,
			// isFullScreen,
			// onToggleFullScreen,
		};

	let {
			onClose,
			libraryId,
			creativeId,
			versionId,
		} = props
		, versionInfo = {}
		, [isSavingAs, setIsSavingAs] = useState(false)
		, formValues = useSelector(getFormValues(EDIT_SOCIAL_VERSION_2))
		, dispatch = useDispatch()
		, $saveAsModal = null
		, bladeClasses = {
			"main-content-container":true,
			"is-previewing":true,
		}
		, {
			creativeDetails,
			variables,
			versionName,
			totalItems,
			isFormValid,
			isSaving,
		} = useSelector((state) => {
			return {
				creativeDetails:state.creativeDetails,
				variables:state.versionDetails.items,
				totalItems: state.creativeVersions.totalItems,
				versionName:state.versionDetails.info?.name,
				isFormValid: formIsValid(state),
				isSaving: state.versionDetails.isSavingVariables,
			};
		})
		;

	const [, { }, ModalStackHead] = useModalStack({ commonModalProps });

	useEffect(() => {
		dispatch(loadVersionDetails(libraryId, parseInt(creativeId), parseInt(versionId)));
		dispatch(getVersionInfo(versionId));
	}, [libraryId, creativeId, versionId]);

	function closeModal(){
		dispatch(clearVersionDetails());
		onClose();
	}
	function confirmedClose(){
		closeModal();
	}

	function saveAsVersion() {
		setIsSavingAs(true);
	}

	function Footer(){
		let canSave = true;

		if(!isFormValid){
			canSave = false;
		}

		if(isSaving){
			canSave = false;
		}

		return [
			<Button key="cancel" theme="default" onClick={confirmedClose}>Cancel</Button>
			, <div key="save" className="footer-actions">
				<Button
					disabled={!canSave || isMaxDynamicSocialVersions(totalItems, creativeDetails)}
					onClick={saveAsVersion}>Save As...</Button>
				<Button
					disabled={!canSave}
					theme="green"
					type="submit"
					form={EDIT_SOCIAL_VERSION_2}
				>Save Version</Button>
			</div>
		];
	}

	function Content(){
		return (
			<div className={ClassNames(bladeClasses)}>
				<Toolbar />
				<EditSocialVersion
					variables={variables}
					libraryId={libraryId}
					versionId={versionId}
					creativeId={creativeId}
					closeModal={closeModal}
				/>
				<InlineVersionPreview isPreviewing />
			</div>
		);
	}

	if(isSavingAs){
		let saveProps = {
			libraryId,
			creativeId,
			version: {
				name:versionName,
				variableConfig: addLibraryIdToVideos(formValues, libraryId),
			},
			onClose(newId){
				setIsSavingAs(false);
				history.replace(`/library/${libraryId}/creative/${creativeId}/versions/${newId}/modal/edit-version2/`);
			},
		};

		$saveAsModal = <SaveAsModal {...saveProps} />;
	}


	let modalProps = {
		...commonModalProps,
		title:`Edit Version - ${versionName}`,
		className: "social-edit-version-blade show-preview-side",

		renderFooter: Footer,
		renderContent: Content,
		onClose: confirmedClose,
	};

	const blade = ModalStackHead ? <ModalStackHead versionInfo={versionInfo} creativeId={creativeId} /> : <Modal {...modalProps} />;

	return (
		<>
			{$saveAsModal}
			{blade}
		</>
	);
}

SocialVersionBlade.displayName = "SocialVersionBlade";
